<template>
  <Content title="客户这样评价我们">
    <div id="commentCarousel" class="carousel slide" data-ride="carousel" data-interval="false">
      <div class="carousel-inner h-100">
        <div class="carousel-item comment-item active">
          <div class="w-100 letter-cover-m">
            <div class="letter-title">表扬信</div>
            <div class="mb-2">深圳市特航航空服务有限公司：</div>
            <div>
              我单位与贵公司合作以来，合作非常顺利，贵公司服务人员陆银宣24小时随时可联系到本人，及时协助我单位处理紧急出行事务，特别在团队出行上，因我们多次进行人员调整，陆陆不厌其烦，尽心尽力帮我们更改人员的改签和退票，做账单明细，以免遗漏订错行程，确保出行事务顺利进行，特提出表扬。
            </div>
            <div class="letter-sign">
              <div>深圳市XX大队</div>
              <div>2019年01月24日</div>
            </div>
          </div>
        </div>
        <div class="carousel-item comment-item">
          <div class="w-100 letter-cover-m">
            <div class="letter-title">表扬信</div>
            <div class="mb-2">深圳市特航航空服务有限公司：</div>
            <div>
              感谢贵司长期以来对我院购票工作的支持，同时，也对贵司王蓉同志提出表扬。<br />
              王蓉同志长期对接我院购票相关工作，我院对其工作表现表示赞许，一是工作专业度高，熟练掌握购票、退改流流程，在对接我院工作中，未发生差错；二是服务热情，每次服务均能主动问好，礼貌用语。由于工作所需，我院经常在节假日和晚上购票，她均能积极配合，无推脱，无怨言；三是工作效率高，对我院的要求，能做到快速反应和处理，保障我院工作的顺利开展。
              特此表扬。
            </div>
            <div class="letter-sign">
              <div>深圳XX学院</div>
              <div>2019年10月24日</div>
            </div>
          </div>
        </div>
        <div class="carousel-item comment-item">
          <div class="w-100 letter-cover-m">
            <div class="letter-title">表扬信</div>
            <div class="mb-2">深圳市特航航空服务有限公司：</div>
            <div>
              你们好！首先非常感谢贵司对我校国际合作工作的大力支持!自2016年至今，贵司为我校提供了机票、住宿、城市间交通等多方面的出访服务保障与支撑，为我校国际合作工作提供了重要的保障。贵司王川川先生常年对接我部，协调跟进学校主要的出访服务保障，服务状态佳、工作效率高、响应及时。由于国际合作工作常常有时差，工作中不可避免在中国正常工作时间以外开展工作，王川川先生加班加点，任劳任怨，积极响应我校工作人员在境外时的出访工作需求，为我校出访工作顺利进行提供了重要的支持。<br />
              衷心感谢包括贵司王川川先生在内的工作人员对我校国际合作工作的支持……
            </div>
            <div class="letter-sign">
              <div>XX国际合作部</div>
              <div>2020年1月8日</div>
            </div>
          </div>
        </div>
      </div>
      <a class="carousel-control-prev" href="#commentCarousel" role="button" data-slide="prev">
        <span class="carousel-preview-btn" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#commentCarousel" role="button" data-slide="next">
        <span class="carousel-next-btn" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
export default {
  name: 'MobileComment',
  components: { Content },
  setup() {},
}
</script>

<style lang="scss" scoped>
.letter-cover-m {
  background-image: url('/images/mobile/letter-paper.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 428px;
  padding: 15px 35px;
  font-size: 12px;
}

.letter-title {
  font-size: 13px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 16px;
}

.letter-sign {
  position: absolute;
  bottom: 56px;
}

.carousel-control-prev,
.carousel-control-next {
  width: 8%;
}

.carousel-control-prev {
  left: -20px;
}
.carousel-control-next {
  right: -20px;
}
</style>
